export default __webpack_public_path__ + "static/media/exterior2.99420bdb.e3be5eb5.jpg";